import {
    Selector as PropsSelector,
    Layout as PropsLayout,
} from '@/models/Props';

import './Main.scss';

const Main = ({ ariaLabel, children }: PropsSelector & PropsLayout) => {
    return <main aria-label={ariaLabel}>{children}</main>;
};

export default Main;
